var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPenOutlinedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.7001 3.23611L12.7788 0.299887C12.5858 0.10782 12.3245 0 12.0522 0C11.7799 0 11.5187 0.10782 11.3256 0.299887L0.969226 10.6414L0.0236625 14.7222C-0.0089563 14.8714 -0.0078381 15.026 0.0269353 15.1747C0.0617087 15.3234 0.129259 15.4624 0.224651 15.5816C0.320043 15.7009 0.440868 15.7973 0.578299 15.8639C0.715729 15.9304 0.866293 15.9655 1.01899 15.9664C1.09014 15.9736 1.16184 15.9736 1.23299 15.9664L5.35863 15.0208L15.7001 4.68929C15.8922 4.49625 16 4.23501 16 3.9627C16 3.69039 15.8922 3.42915 15.7001 3.23611ZM4.86097 14.125L0.99411 14.9362L1.87498 11.144L9.62362 3.42522L12.6096 6.41121L4.86097 14.125ZM13.2765 5.6896L10.2905 2.70361L12.0224 0.981688L14.9586 3.96768L13.2765 5.6896Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPenOutlinedIcon);
export default __webpack_public_path__ + "static/media/editPenOutlinedIcon.159e280fab4913f0da12dd1bb93c5cff.svg";
export { ForwardRef as ReactComponent };